import HOC from '../HOC';
import {entertainment} from '../utility';

let Entertainment = () => {return null;}

export default HOC(Entertainment, entertainment);



// WEBPACK FOOTER //
// ./src/components/News/Entertainment.js